import React, {Fragment, useContext, useEffect, useState} from "react";
import {useParams} from 'react-router-dom'
import {ServerContext} from "../../serverContext/ServerProvider";
import {Loader} from "../../components/Loader";
import {Image} from "../../components/Image";


export const OrderPage = () => {
    const {orderId} = useParams()
    const {getAllOrders, orders} = useContext(ServerContext)
    const [loading, setLoading] = useState(true)


    useEffect(() => {
        async function wtf() {
            await getAllOrders(() => {
                setLoading(false)
            })
        }
        if(!orders) {
            wtf()
        } else {
            setLoading(false)
        }
    }, [])

    const getSummary = (goods) => {
        return goods.reduce((result, good) => result+good.amount, 0)
    }

    const getDate = (raw) => {
        const date = new Date(raw)
        return (date.getMonth()+1)+'.'+date.getDate()+'.'+date.getFullYear()+', '+date.getHours()+':'+date.getMinutes()
    }

    return (
        <Fragment>
            {loading ? <Loader/> : (
                <div className='container-sm mt-5'>
                    <h2 style={{margin: '200px 0', marginBottom: '40px'}}>Order:</h2>
                    {orders.map(order => {
                        if (order._id === orderId) {
                            return (
                                <Fragment>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>Order ID:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{orderId}</h3>
                                        </div>
                                    </div>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>Date:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{getDate(order.date)}</h3>
                                        </div>
                                    </div>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>Payment:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{getSummary(order.goods)}$</h3>
                                        </div>
                                    </div>
                                    <h2 style={{margin: '40px 0', marginTop: '80px'}}>User:</h2>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>User Name:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{order.user.name}</h3>
                                        </div>
                                    </div>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>User Phone:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{order.user.phone}</h3>
                                        </div>
                                    </div>
                                    <div className="row mb-5 mt-5">
                                        <div className="col-4 text-muted">
                                            <h3>User email:</h3>
                                        </div>
                                        <div className="col-8 text-dark">
                                            <h3>{order.user.email}</h3>
                                        </div>
                                    </div>
                                    <h2 style={{margin: '40px 0', marginTop: '80px'}}>Goods:</h2>
                                    {order.goods.map(good => (
                                        <div className="row mb-5 mt-5 border p-4">
                                            <h3 className='mb-5'>{good.title}</h3>
                                            <div className="w-100"/>
                                            <div className="col-3 text-muted">
                                                <Image style={{maxWidth: '90%'}} src={good.color.image}/>
                                            </div>
                                            <div className="col-3 text-dark">
                                                <h4 className='text-muted'>Color:</h4>
                                                <h4>{good.color.title}</h4>
                                            </div>
                                            <div className="col-3 text-dark">
                                                <h4 className='text-muted'>Quantity:</h4>
                                                <h4>{good.quantity}</h4>
                                            </div>
                                            <div className="col-3 text-dark">
                                                <h4 className='text-muted'>Price:</h4>
                                                <h4>{good.amount}</h4>
                                            </div>
                                            <div className="col-6 text-dark mt-5">
                                                <h4 className='text-muted'>Description:</h4>
                                                {good.option.options.map(option => <p>{option}</p>)}
                                            </div>
                                        </div>
                                    ))}
                                </Fragment>
                            )
                        }
                    })}
                </div>
            )}
        </Fragment>
    )
}